$(document).ready(function() {
  // Reset tracking UI state
  function resetTrackingUI() {
    $('.trackOrder').hide();
    $('.no-trackOrder').hide();
    $('.IncorrectTrackOrder').hide();
    $('.MainTrackOrder').show();
    $('.before_loader-gif').show();
    $('[id^="js-courier_awb"]').text('');
    $('[id^="js-courier_name"]').text('');
    $('[id^="js-expected_delivery"]').text('');
    $('[id^="js-tracking_status"]').text('');
    $('#js-tracking_id').text('');
    $('[data-status]').removeClass('completed');
    $('[class^="awb_"]').hide();
    $('[data-status="RTO"]').hide().removeClass('completed');
  }
  $('.track_order_btn').click(function() {
    var trackid = $('#track-order-no').val().toUpperCase();
    if (trackid === "") {
      $("#track-order-no").css("border-color", "red");
      return;
    }
    resetTrackingUI();
    var url = `https://hul-services.enscommerce.in/liquidiv/trackorder/tracking`;
    $.ajax({
      type: "POST",
      url: url,
      contentType: 'application/json',
      data: JSON.stringify({
        ordername: trackid
      }),
      dataType: 'json',
      success: function(response) {
        var isSuccess = response?.success;
        var status = response?.data?.status;
        var message = response?.data?.message;
        var trackingNumber = response?.data?.shippingPackages?.[0]?.trackingNumber;
        console.log("trackingNumber: ", trackingNumber);
        var trackingStatus = response?.data?.shippingPackages?.[0]?.trackingStatus;
        if (isSuccess && status === "COMPLETE" && trackingNumber) {
          var trackingUrl = "https://track.shipway.com/t/" + trackingNumber;
          // wait 2–3 seconds before redirect
          setTimeout(function() {
            window.location.href = trackingUrl;
          }, 2500);
        } else if (isSuccess && status === "PROCESSING" && trackingNumber) {
          $('.IncorrectTrackOrder').css('display', 'block');
          $('#incorrect-status').text("Your order is currently in progress. It has yet to be assigned or picked. Please visit in 4-5 hrs as it moves to the next stage.");
          $('.MainTrackOrder').css('display', 'none');
          $('.before_loader-gif').css('display', 'none');
        } else if (isSuccess && status === "PROCESSING" && trackingNumber === undefined) {
          $('.IncorrectTrackOrder').css('display', 'block');
          $('#incorrect-status').text("Your order is currently in progress. It has yet to be assigned or picked. Please visit in 4-5 hrs as it moves to the next stage.");
          $('.MainTrackOrder').css('display', 'none');
          $('.before_loader-gif').css('display', 'none');
        } else if (isSuccess && status === "PROCESSING" && trackingNumber === null) {
          $('.IncorrectTrackOrder').css('display', 'block');
          $('#incorrect-status').text("Your order is currently in progress. It has yet to be assigned or picked. Please visit in 4-5 hrs as it moves to the next stage.");
          $('.MainTrackOrder').css('display', 'none');
          $('.before_loader-gif').css('display', 'none');
        } else if (isSuccess && status === "CANCELLED") {
          $('.IncorrectTrackOrder').css('display', 'block');
          $('#incorrect-status').text("Your order has been cancelled.");
          $('.MainTrackOrder').css('display', 'none');
          $('.before_loader-gif').css('display', 'none');
        } else if (!isSuccess && message && message.toLowerCase().includes("order not found")) {
          $('.IncorrectTrackOrder').show();
          $('#incorrect-status').text("Please enter the correct Order ID.");
          $('.MainTrackOrder').hide();
          $('.before_loader-gif').hide();
        }
      },
      error: function(error) {
        $('.before_loader-gif').hide();
        $('.IncorrectTrackOrder').show();
        // $('#incorrect-status').text("Something went wrong. Please try again later.");
        $('#incorrect-status').text("Please enter the correct Order ID.");
      }
    });
  });
  // Clear error border color on input
  $("#track-order-no").on("input", function() {
    $(this).css("border-color", "");
  });
  // Optional: Support pressing "Enter" to trigger search
  $("#track-order-no").keypress(function(e) {
    if (e.which === 13) {
      $('.track_order_btn').click();
    }
  });
});